enum ConsultationSessionStatus {
  Submitted = 21,
  Endorsed = 51,
  Reject = 52
}
enum ActionType {
  Created = 0,
  Released = 11,
  Submitted = 21,
  RESubmitted = 22,
  Endorsed = 51,
  Reject = 52
}
enum SsessionType {
  SitIn = 1,
  VideoRecording = 2
}
enum CompletionStatus {
  Save = 0,
  Submitted = 20,
  Completed = 90,
  Released = 52
}
export const ConsultationSessionEnum = {
  SsessionType,
  CompletionStatus,
  ActionType,
  ConsultationSessionStatus
}
